export default __webpack_public_path__ + "static/media/21.c2265e24.jpg";